<template>
    <div v-if="employeequalification" class="d-flex justify-content-center">
        <div class="mybadge" :style="{
            background: 'linear-gradient(to bottom right, ' + pSBC(0.2, color) + ' 0%, ' + pSBC(-0.2, color) + ' 100%)',
            color: '#000000'
        }">
            <div class="circle">
            </div>
            <i v-if="!employeequalification?.refresh_at" class="fa-solid fa-check text-success"
                :title="formatDate(employeequalification?.start_at)"></i>
            <i v-if="employeequalification?.refresh_at" :class="{
                'text-success': !warning,
                'text-danger': warning,

            }" class="fa-solid fa-hourglass me-1" :title="formatDate(employeequalification?.refresh_at)"></i>
            <div class="ribbon p-0" v-if="!employeequalification.old">
                <span v-if="employeequalification?.refresh_at">{{ days }} {{ $trans.get('__JSON__.days') }}</span><br
                    v-if="employeequalification?.refresh_at">
                <span>{{ $trans.get('__JSON__.starting at') }} {{ formatDate(employeequalification?.start_at) }} </span>
                <div class="age" :style="{ width: getAgePercentage(employeequalification) + '%', background: color }"></div>
            </div>
        </div>
    </div>


    <span role="button" class="hoverplus" v-else><i class="fa-solid fa-plus fa-2x text-primary"></i></span>
</template>

<script>
/*
<span role="button" v-if="employeequalification">
        <i v-if="!employeequalification?.refresh_at" class="fa-solid fa-check fa-2x text-success" v-tooltip
            :title="formatDate(employeequalification?.start_at)"></i>&nbsp;
        <span role="button" v-if="employeequalification?.refresh_at"><i :class="{
            'text-success': !warning,
            'text-danger': warning,

        }" class="fa-solid fa-hourglass me-1" v-tooltip :title="formatDate(employeequalification?.refresh_at)"></i>
            {{ days }}</span>
    </span>
*/
import axios from "axios";

export default {
    setup() {
    },
    name: "QualificationCell",
    created() {
    },
    props: {
        employeequalification: Object,
        warningdays: Number
    },
    data() {
        return {
        };
    },
    computed: {
        warning() {
            if (this.employeequalification.old == true) {
                return false;
            }
            return this.warningdays > this.days;
        },
        color() {
            if (this.employeequalification.old == true) {
                return '#d0d7f5';
            }
            if (!this.employeequalification?.refresh_at && this.employeequalification.old == false) {
                return '#0000aa';
            }
            if (this.warningdays > this.days && this.employeequalification.old == false) {
                return '#aa0000';
            }
            return '#00aa00'
        },
        days() {
            return Math.round((new Date(this.employeequalification?.refresh_at).getTime() - new Date().getTime()) / 1000 / 60 / 60 / 24);
        }
    },
    mounted() {
    },
    methods: {
        getAgePercentage(qualification) {
            const intervaldays = Math.round((new Date(this.employeequalification?.refresh_at).getTime() - new Date().getTime(this.employeequalification?.start_at)) / 1000 / 60 / 60 / 24);
            return Math.round(this.days / (intervaldays / 100));
        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        shadeColor(color, percent) {

            var R = parseInt(color.substring(1, 3), 16);
            var G = parseInt(color.substring(3, 5), 16);
            var B = parseInt(color.substring(5, 7), 16);

            R = parseInt(R * (100 + percent) / 100);
            G = parseInt(G * (100 + percent) / 100);
            B = parseInt(B * (100 + percent) / 100);

            R = (R < 255) ? R : 255;
            G = (G < 255) ? G : 255;
            B = (B < 255) ? B : 255;

            R = Math.round(R)
            G = Math.round(G)
            B = Math.round(B)

            var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
            var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
            var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

            return "#" + RR + GG + BB;
        },
        pSBC(p, c0, c1, l) {
            let r, g, b, P, f, t, h, i = parseInt, m = Math.round, a = typeof (c1) == "string";
            if (typeof (p) != "number" || p < -1 || p > 1 || typeof (c0) != "string" || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
            h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == "c" ? !h : false : h, f = this.pSBCr(c0), P = p < 0, t = c1 && c1 != "c" ? this.pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 } : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
            if (!f || !t) return null;
            if (l) r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
            else r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5), g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
            a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
            if (h) return "rgb" + (f ? "a(" : "(") + r + "," + g + "," + b + (f ? "," + m(a * 1000) / 1000 : "") + ")";
            else return "#" + (4294967296 + r * 16777216 + g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)
        },
        pSBCr(d) {
            let i = parseInt, m = Math.round, a = typeof (c1) == "string";
            let n = d.length, x = {};
            if (n > 9) {
                [r, g, b, a] = d = d.split(","), n = d.length;
                if (n < 3 || n > 4) return null;
                x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1
            } else {
                if (n == 8 || n == 6 || n < 4) return null;
                if (n < 6) d = "#" + d[1] + d[1] + d[2] + d[2] + d[3] + d[3] + (n > 4 ? d[4] + d[4] : "");
                d = i(d.slice(1), 16);
                if (n == 9 || n == 5) x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255, x.a = m((d & 255) / 0.255) / 1000;
                else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1
            } return x
        }

    }
};
</script>

<style scoped></style>
